import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Wind = createReactComponent("Wind", ["svg", defaultAttributes, [["path", {
  d: "M9.59 4.59A2 2 0 1111 8H2m10.59 11.41A2 2 0 1014 16H2m15.73-8.27A2.5 2.5 0 1119.5 12H2",
  key: "3ff5yx"
}]]]);
export default Wind;